import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import gsap from "gsap";
import { FaRegFilePdf } from "react-icons/fa6";
import { HiOutlineDownload } from "react-icons/hi";
import axios from "axios";
import { mirage } from "ldrs";
import { useParams } from "react-router-dom";
const Share = () => {
  const { id } = useParams();
  mirage.register();
  const loader = useRef(null);
  const [saved, setsaved] = useState(true);
  const messageText = useRef(null);
  const message = useRef(null);
  const messageSpanSvg = useRef(null);
  useEffect(() => {
    document.querySelector(".pdf").addEventListener("click", () => {
      window.print();
    });
  }, []);
  useEffect(() => {
    if (id) fetchData();
  }, []);
  const fetchData = async () => {
    showloader();
    try {
      const data = {
        id: id,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/share",
        data
      );
      if (response.data.state === true) {
        hideloader();
        var section = document.querySelector("section");
        section.innerHTML = "";
        var output = creatememo(response.data.memos);
        section.appendChild(output);
      } else {
        setsaved(null)
        hideloader();
        await showMessage(response.data.message);
      }
    } catch (error) {
      hideloader();
    }
  };
  function creatememo(data) {
    var result = document.createElement("div");
    result.innerHTML = "";
    result.classList.add("result");
    var h4 = document.createElement("h4");
    h4.id = "Q";
    var spansvg = `<span id="gemini-svg">
              <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8.016A8.522 8.522 0 008.016 16h-.032A8.521 8.521 0 000 8.016v-.032A8.521 8.521 0 007.984 0h.032A8.522 8.522 0 0016 7.984v.032z"
                  fill="url(#prefix__paint0_radial_980_20147)"
                />
                <defs>
                  <radialGradient
                    id="prefix__paint0_radial_980_20147"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(16.1326 5.4553 -43.70045 129.2322 1.588 6.503)"
                  >
                    <stop offset=".067" stop-color="#9168C0" />
                    <stop offset=".343" stop-color="#5684D1" />
                    <stop offset=".672" stop-color="#1BA1E3" />
                  </radialGradient>
                </defs>
              </svg>
            </span>`;
    h4.innerHTML = spansvg;
    var question = data.question;
    h4.innerHTML += question;
    var actions = document.createElement("div");
    actions.id = "actions";

    var copy = document.createElement("span");
    copy.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>`;
    var copy_container = document.createElement("div");
    copy_container.innerHTML = data.answer;
    copy.addEventListener("click", async () => {
      var range = document.createRange();
      range.selectNode(result.querySelector(".result>#answer_text"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      setsaved("done");
      await showMessage("text copied");
    });
    actions.appendChild(copy);

    result.appendChild(h4);
    result.innerHTML += data.answer;
    result.appendChild(actions);
    return result;
  }
  function showloader() {
    gsap.to(loader.current, { opacity: 1 });
  }
  function hideloader() {
    gsap.to(loader.current, { opacity: 0 });
  }
  async function showMessage(text) {
    const tl = gsap.timeline({});
    message.current.style = "";
    await tl
      .fromTo(
        message.current,
        {
          top: "-2rem",
        },
        {
          top: "1rem",
          ease: "elastic.out(1,0.5)",
          duration: 1.5,
          overwrite: true,
        }
      )
      .fromTo(
        message.current,
        {
          minWidth: "0px",
        },
        {
          minWidth: "180px",
          ease: "elastic.out(1,0.75)",
          duration: 1,
        }
      )
      .fromTo(
        messageText.current,
        {
          opacity: 0,
          flexGrow: 0,
          textContent: "",
          height: "0",
        },
        {
          textContent: text,
          flexGrow: 1,
          height: "fit-content",
          opacity: 1,
        }
      )
      .fromTo(
        messageSpanSvg.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
        }
      )
      .to(messageText.current, {
        opacity: 0,
        delay: 2,
      })
      .to(messageText.current, {
        flexGrow: 0,
        height: "0",
      })
      .to(messageSpanSvg.current, {
        opacity: 0,
        delay: -1,
      })
      .to(messageText.current, {
        textContent: "",
      })
      .to(message.current, {
        minWidth: "0px",
      })
      .to(message.current, {
        top: "-3rem",
      });
  }
  const error = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
  const done = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
  return (
    <article>
      <div className="pdf">
        <span>
          <FaRegFilePdf />
        </span>
        <button>
          <HiOutlineDownload />
        </button>
      </div>
      <div className="message" ref={message}>
        <p ref={messageText}></p>
        <span ref={messageSpanSvg}>
          {saved === null && error}
          {saved === "done" && done}
        </span>
      </div>
      <div className="hero">
        <h1 id="color">shared memo</h1>
      </div>
      <section></section>
      <div className="loader" ref={loader}>
        <l-mirage size="60" speed="2.5" color="black"></l-mirage>
      </div>
    </article>
  );
};

export default Share;
